export default {
	"menu": {
		// base
		"home": "首页",
	},
	"components": {
		"treeTable": {
			"emptyText": "暂无数据"
		}
	},
	"enum": {
		"resourceType": {
			"root": "根目录",
			"directory": "目录",
			"menu": "菜单",
			"action": "功能",
			"tab": "页签",
			"group": "分组"
		},
		"gender": {
			"Male": "男",
			"Female": "女"
		},
		"sortType": {
			"former": "原位置",
			'top': "置顶",
			'bottom': "置底",
			'upDown': "上移或下移"
		},
		yesOrNo: {
			"Yes": "是",
			"No": "否"
		},
		flowState: {
			"unStart": "待发起",
			// "start": "已发起",
			"running": "审批中",
			"end": "已审批",
			// "revoke": "已撤销",
		},
		approvalType: {
			"pending": "待审批",
			"approved": "已审批",
		},
		approvalAction: {
			'pass': "通过",
			'veto': "否决",
			'back': "打回",
		},
	},
	"tips": {
		"add": {
			"success": "添加成功",
		},
		"save": {
			"success": "保存成功",
			"error": "数据没有发生变化,请确认后重新操作"
		},
		"update": {
			"success": "修改成功"
		},
		"delete": {
			"success": "删除成功"
		},
		"landInvest": {
			"save": {
				"success": "土地保存成功"
			}
		},
		"decision": {
			"success": "决策评估成功"
		}
	}
}